import React, { useState } from "react";
import { Button, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import gem from "../../assets/images/header/gem.png";
import arrow from "../../assets/images/sidebar/arrow.svg";
import rouletteicon from "../../assets/images/sidebar/roulette.svg";
import diceicon from "../../assets/images/sidebar/dice.svg";
import minesicon from "../../assets/images/sidebar/mines.svg";
import towericon from "../../assets/images/sidebar/tower.svg";
import sloticon from "../../assets/images/sidebar/slots.svg";
import livegameicon from "../../assets/images/sidebar/livegame.svg";
import monopolyicon from "../../assets/images/sidebar/monopoly.png";
import crazyicon from "../../assets/images/sidebar/crazy.png";
import minesActive from '../../assets/images/sidebar/mines-active.svg';
import diceActive from '../../assets/images/sidebar/dice-active.svg';
import towerActive from '../../assets/images/sidebar/tower-active.svg';
import slotsActive from '../../assets/images/sidebar/slots-active.svg';
import liveGameActive from '../../assets/images/sidebar/livegame-active.svg';
import roulettenotActive from '../../assets/images/sidebar/roulette-notActive.svg';
import "./sidebar.css";

const Sidebar = () => {
  const [hideGames, setHidegames] = useState(false);
  const [hidefavourite, setHideFavourite] = useState(false);
  const handleGames = () => {
    setHidegames(!hideGames);
  };
  const handleFavourites = () => {
    setHideFavourite(!hidefavourite);
  };
  return (
    <div className="sidebar-content">
      <div className={`sidebar-menu ${hideGames ? 'hide-games' : ''}`}>
        <div className="sidebar-menu-header" onClick={handleGames}>
          <h4>
            Games <img src={arrow} alt="" />
          </h4>
        </div>

          <div className="sidebar-menu-body">
            <Nav>
              <NavLink className="nav-link" exact to="/roulette">
              <img src={rouletteicon} alt="" className="active-img" />  <img src={roulettenotActive} alt="" className="navbar-img" /> <span>Roulette</span>
              </NavLink>
              <NavLink className="nav-link" to="/dice">
              <img src={diceActive} alt="" className="active-img" /> <img src={diceicon} alt="" className="navbar-img" /> <span>Dice</span>
              </NavLink>
              <NavLink className="nav-link" to="/mines">
              <img src={minesActive} alt="" className="active-img" />   <img src={minesicon} alt="" className="navbar-img" /> <span>Mines</span>
               
              </NavLink>
              <NavLink className="nav-link" to="/tower">
              <img src={towerActive} alt="" className="active-img" />  <img src={towericon} alt="" className="navbar-img" /> <span>Tower</span>
              </NavLink>
              <NavLink className="nav-link" to="/slots">
              <img src={slotsActive} alt="" className="active-img" />  <img src={sloticon} alt="" className="navbar-img" /> <span>Slots</span>
              </NavLink>
              <NavLink className="nav-link" to="/livegames">
              <img src={liveGameActive} alt="" className="active-img" />   <img src={livegameicon} alt="" className="navbar-img" /> <span>Live Games</span>
              </NavLink>
            </Nav>
          </div>
      </div>

      <div className={`sidebar-menu ${hidefavourite ? 'hide-favourite' : ''}`}>
        <div className="sidebar-menu-header" onClick={handleFavourites}>
          <h4>
            Favorites <img src={arrow} alt="" />
          </h4>
        </div>
   
          <div className="sidebar-menu-body">
            <Nav>
              <NavLink className="nav-link" to="/monopoly">
                <img src={monopolyicon} alt="" /> <span>Monopoly</span>
              </NavLink>
              <NavLink className="nav-link" to="/crazytime">
                <img src={crazyicon} alt="" /> <span>Crazy Time</span>
              </NavLink>
            </Nav>
          </div>
      </div>

      <div className="claim-rake">
        <h4>Rakeback</h4>
        <p>Instantly claim your rakeback!</p>
        <Button>
          CLAIM <img src={gem} alt="" />
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
